/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NftRewardMetadata } from './NftRewardMetadata';
import {
    NftRewardMetadataFromJSON,
    NftRewardMetadataFromJSONTyped,
    NftRewardMetadataToJSON,
    NftRewardMetadataToJSONTyped,
} from './NftRewardMetadata';
import type { NftRewardPrize } from './NftRewardPrize';
import {
    NftRewardPrizeFromJSON,
    NftRewardPrizeFromJSONTyped,
    NftRewardPrizeToJSON,
    NftRewardPrizeToJSONTyped,
} from './NftRewardPrize';

/**
 * 
 * @export
 * @interface GetNftRewardResponse
 */
export interface GetNftRewardResponse {
    /**
     * 
     * @type {NftRewardMetadata}
     * @memberof GetNftRewardResponse
     */
    nftReward: NftRewardMetadata;
    /**
     * 
     * @type {Array<NftRewardPrize>}
     * @memberof GetNftRewardResponse
     */
    prizes: Array<NftRewardPrize>;
}

/**
 * Check if a given object implements the GetNftRewardResponse interface.
 */
export function instanceOfGetNftRewardResponse(value: object): value is GetNftRewardResponse {
    if (!('nftReward' in value) || value['nftReward'] === undefined) return false;
    if (!('prizes' in value) || value['prizes'] === undefined) return false;
    return true;
}

export function GetNftRewardResponseFromJSON(json: any): GetNftRewardResponse {
    return GetNftRewardResponseFromJSONTyped(json, false);
}

export function GetNftRewardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNftRewardResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'nftReward': NftRewardMetadataFromJSON(json['nftReward']),
        'prizes': ((json['prizes'] as Array<any>).map(NftRewardPrizeFromJSON)),
    };
}

export function GetNftRewardResponseToJSON(json: any): GetNftRewardResponse {
    return GetNftRewardResponseToJSONTyped(json, false);
}

export function GetNftRewardResponseToJSONTyped(value?: GetNftRewardResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nftReward': NftRewardMetadataToJSON(value['nftReward']),
        'prizes': ((value['prizes'] as Array<any>).map(NftRewardPrizeToJSON)),
    };
}

